// Brand constants — see CLAUDE.md § Branding.
// All logos must reference logo.asset.college; never use the legacy
// pub-*.r2.dev URLs.

export const BRAND = {
  colour: {
    blueMid: '#20C4F4',
    blueDark: '#008DD2',
    black: '#1A1A1A',
  },
  logo: {
    horizontalLight: 'https://logo.asset.college/asset-college-logo.svg',
    horizontalDark: 'https://logo.asset.college/asset-college-logo-white.svg',
    squareLight: 'https://logo.asset.college/asset-logo-square.svg',
    squareDark: 'https://logo.asset.college/asset-logo-square-white.svg',
  },
} as const;
